import { render, staticRenderFns } from "./milady-cmp.vue?vue&type=template&id=2b6dcfb7&"
import script from "./milady-cmp.vue?vue&type=script&lang=js&"
export * from "./milady-cmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports